const removeInvalidCharacters = (value: string) => {
    return value.replace(/[<>\\/]/g, '');
};

export default removeInvalidCharacters;
